import { render, staticRenderFns } from "./MastitisMilkQuality.vue?vue&type=template&id=2f4f1373&"
import script from "./MastitisMilkQuality.vue?vue&type=script&lang=js&"
export * from "./MastitisMilkQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports